<template>
  <div class="cart-summary-container">
    <div class="backdrop" @click="click"></div>
    <div class="cart-bottom"></div>
    <div class="cart-table-wrapper">
      <cart-table></cart-table>
    </div>
  </div>

</template>

<script>
import CartTable from './CartTable'

export default {
  name: 'CartSummary',
  components: { CartTable },

  methods: {
    click (event) {
      this.$emit('close', event)
    }
  }
}
</script>

<style scoped lang="scss">
@import '../../styles/variables';
.cart-summary-container {
  background: linear-gradient(to right, $sc-primary, $sc-secondary);
  color: $sc-text-light;

  .cart-table-wrapper {
    padding-top: 36px;
    margin: 0 auto;

    /deep/ .cart-table {
      width: 70%;
      margin: 0 auto;

      tr td:nth-child(6) {
        background: transparent;
      }

      .total-cost-label, .monthly-cost-label, .discount-label {
        text-align: right;
      }

      tr.spacer.monthly, tr.monthly-net-total, tr.monthly-vat-cost, tr.monthly-gross-total {
        display: none;
      }
    }

    /deep/ .sum-container {
      width: 100%;
      background: $sc-primary;

      .sum {
        width: 70%
      }
    }
  }
}

.backdrop {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: $sc-confirmdialog-backdrop-color;
  z-index: -1;
}

.cart-bottom {
  height: 108px;
  position: absolute;
  width: 100%;
  bottom: 0;
  background: $sc-primary;
  z-index: -1
}

@media(max-width: 768px) {
  .cart-summary-container .cart-table-wrapper{
    padding: 10px 20px;
  }

  .cart-bottom{
    height: 80px;
  }
}
</style>
